type TBenefitColor = 'lightBlue' | 'lightPeach' | 'lightPurple'

const colors: TBenefitColor[] = ['lightBlue', 'lightPeach', 'lightPurple']

export const getBenefitBgColor = (index: number) => {
	const color = colors[index % colors.length]
	return `var(--${color})`
}
